import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      fill: "rgb(var(--v-theme-white, 255, 255, 255))",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.585 3A2.415 2.415 0 0 1 21 5.415v13.171A2.414 2.414 0 0 1 18.585 21H5.415A2.415 2.415 0 0 1 3 18.585V5.415A2.415 2.415 0 0 1 5.415 3zm-2.511 5.691a.88.88 0 0 0-1.237.112l-3.775 4.53-1.515-1.515a.88.88 0 0 0-1.242 0 .88.88 0 0 0 0 1.242l2.195 2.195a.88.88 0 0 0 1.296-.058l4.39-5.268a.88.88 0 0 0-.112-1.237z"
    }, null, -1)
  ]))]))
}
export default { render: render }